import React from 'react'
import { useSelector } from 'react-redux'
import styled, { withTheme } from 'styled-components'
import { Property } from 'csstype'

import { WithTheme } from 'src/types'
import { breakpoints } from 'src/styles'
import StationNowPlaying from 'src/components/station/StationNowPlaying'
import AudioControls from 'src/components/media/AudioControls'

import { selectSelectedStation } from 'src/store/data'

const Footer: React.FC<WithTheme> = () => {
  const selectedStation = useSelector(selectSelectedStation)

  if (!selectSelectedStation) return <></>

  return (
    <GridContainer>
      {selectSelectedStation && (
        <>
          <NowPlaying station={selectedStation} />
          <StyledAudioControls />
        </>
      )}
    </GridContainer>
  )
}

export default withTheme(Footer)

const GridContainer = styled.div`
  grid-area: footer;
  background-color: ${({ theme }): Property.Color => theme.colors.panelBackground};
  border-top-color: ${({ theme }): Property.Color => theme.colors.border};
  border-top-width: 1px;
  border-top-style: solid;
  padding-bottom: 1rem;
  display: grid;
  grid-template-areas:
    'now-playing'
    'media-controls';
  ${breakpoints.tablet`
    grid-template-columns: 2fr 1fr;
    grid-template-areas:
      'now-playing media-controls'
  `}
`

const NowPlaying = styled(StationNowPlaying)`
  grid-area: now-playing;
`

const StyledAudioControls = styled(AudioControls)`
  grid-area: media-controls;
`
